import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import LightBox from '../../components/LightBox/LightBox';
import s from './Good.module.scss';

const ImageGallery = props => {
  const { imagesArr, t } = props;
  const [indexImg, setIndexImg] = useState(0);

  useEffect(() => {
    setIndexImg(0);
  }, [imagesArr]);
  if (!imagesArr.length) return null;
  return (
    <div className={s.images}>
      <div className={s.preview}>
        {imagesArr.map((i, index) => (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
          <img
            className={cx(s.itemPreview, indexImg === index && s.active)}
            key={`${i.title}_${i.alt}_${i.src}`}
            onClick={() => setIndexImg(index)}
            src={i.src}
            alt={i.alt}
            title={i.title}
          />
        ))}
      </div>
      <div className={s.mainImg}>
        <LightBox images={imagesArr} currentIndex={indexImg} />
        <p className="note-face-device">
          {t['Внешний вид товара может отличаться от представленного на сайте']}
        </p>
      </div>
    </div>
  );
};

export default ImageGallery;
